<script setup lang="ts">
const props = defineProps({
  folder: null
})
const { leaveSharedFolder, deleteSharedFolder, state: sharedFolderState } = useSharedFolders()
const { navigateToFolder, openFolderInNewTab } = useNavigation()
const { openInstantSearchWithFileIn } = useInstantSearch()
const { askAgentAboutAFile } = useAgent()

if (!props.folder.rootSharedFolderId())
  throw new Error("Shared folder home is not set")

const sharedFolderId = computed(() => props.folder.rootSharedFolderId()!)
const sharedFolderInfo = computed(() => sharedFolderState.value.all[sharedFolderId.value])
const owner = computed(() => sharedFolderInfo.value?.home.impliedSelfRole().isOwner() ?? false)
</script>

<template>
  <div>
    <menu-section>
      <dropdown-item
        @click="navigateToFolder(folder)"
      >
        <template #icon>
          <icon-action size="xs" type="folder" />
        </template>
        <template #default>
          <div>Open</div>
        </template>
      </dropdown-item>
      <dropdown-item
        @click="openFolderInNewTab(folder)"
      >
        Open in new tab
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section v-if="sharedFolderInfo">
      <dropdown-item @click="navigateToFolder(sharedFolderInfo.archive)">
        Go to archive
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item @click="askAgentAboutAFile(folder)">
        <template #icon>
          <icon-action size="xs" type="crystal-ball" />
        </template>
        <template #default>
          <div>Ask Poly...</div>
        </template>
      </dropdown-item>
      <dropdown-item @click="openInstantSearchWithFileIn(folder)">
        <template #icon>
          <icon-action size="xs" type="search" />
        </template>
        <template #default>
          <div>Search within...</div>
        </template>
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item @click="leaveSharedFolder(sharedFolderId)">
        <span>Leave this folder</span>
      </dropdown-item>
    </menu-section>
    <menu-separator v-if="owner" />
    <menu-section v-if="owner">
      <dropdown-item class="delete" @click="deleteSharedFolder(sharedFolderId)">
        <span class="delete">Delete (permanent)</span>
      </dropdown-item>
    </menu-section>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.delete
  @apply text-$global-red-primary

.icon-item
  @apply inline-flex gap-1 inline-center
  .icon
    @apply w-4 h-4 flex items-center justify-center
</style>
